import { localStorageProp } from '@tempots/dom'

export type CookieConsent = 'granted' | 'denied'

/**
 * Analytics cookie consent. null = not decided yet (banner shows).
 * Providers only load after an explicit grant — see track.ts.
 *
 * Stored as the PLAIN string 'granted' / 'denied' (identity serializer,
 * not JSON) so the e2e suite can pre-seed it via Playwright storageState
 * without depending on a serialization format.
 */
export const cookieConsent = localStorageProp<CookieConsent | null>({
  key: 'rh:cookieConsent',
  defaultValue: null,
  serialize: value => value ?? '',
  deserialize: raw => (raw === 'granted' || raw === 'denied' ? raw : null),
})

export function grantCookieConsent(): void {
  cookieConsent.set('granted')
}

export function denyCookieConsent(): void {
  cookieConsent.set('denied')
}
